export default (axios) => async (name, type, startDate, endDate, oauthSignature) => {
  const url = `/v1/excursions`;

  const params = {
    'oauth-signature': oauthSignature
  };

  const payload = {
    metadata: {
      name,
      typeId: type,
      startDate,
      endDate
    }
  };

  const axiosConfig = {
    method: 'POST',
    url,
    params,
    data: payload
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
